import { Component, OnInit } from '@angular/core';
import { MyPropertyService } from 'src/services/my-property';
import { ActivatedRoute } from '@angular/router';
import { ToasterService } from 'src/app/_services/toaster.service';

@Component({
    selector: 'app-approve',
    templateUrl: './approve.component.html',
    styleUrls: ['./approve.component.css'],
    standalone: false
})
export class ApproveComponent implements OnInit {

  key: string;
  email: string;
  data: any;

  constructor(private _MyPropertyService: MyPropertyService, private route: ActivatedRoute, private toastr: ToasterService) {
    this.route.queryParams.subscribe(params => {
      this.key = params['key'];
      this.email = params['email'];
  });
   }

  ngOnInit() {
    this.approve();
  }

  approve() {
    this._MyPropertyService.approve(this.key, this.email).subscribe(data => {
      this.toastr.Info(data);
    });
  }
}
